module.exports = __webpack_public_path__ + "static/promotion-image-e7f739ae48614bd16093fbe2e5e5b7a9.png";